import React from 'react';

import extend from 'lodash/extend';

import _ from '../locale';

type Props = {
    type: 'error' | 'warning' | 'info' | 'success';
    messages: object | [];
    locale: object;
};

export default class InfoBox extends React.PureComponent<Props> {
    // @todo: use styled
    getTypeStyles(type) {
        /*switch (type) {
            case 'error':
                return {
                    backgroundColor: errorBackgroundColor,
                    borderColor: errorBorderColor,
                    color: errorColor,
                };

            case 'warning':
                return {
                    backgroundColor: warningBackgroundColor,
                    borderColor: warningBorderColor,
                    color: warningColor,
                };

            case 'info':
                return {
                    backgroundColor: infoBackgroundColor,
                    borderColor: infoBorderColor,
                    color: infoColor,
                };

            case 'success':
                return {
                    backgroundColor: successBackgroundColor,
                    borderColor: successBorderColor,
                    color: successColor,
                };

            default:
                throw new Error('Unknown InfoBox type "' + type + '"');
        }*/
        return {};
    }

    render() {
        if (!this.props.messages) {
            return null;
        }

        const messages = [];
        let message;
        for (const i in this.props.messages) {
            message =
                this.props.locale && this.props.locale.hasOwnProperty(this.props.messages[i])
                    ? _(this.props.locale[this.props.messages[i]])
                    : this.props.messages[i];

            messages.push(
                this.props.locale && this.props.locale.hasOwnProperty(i)
                    ? _(this.props.locale[i]) + ': ' + message
                    : message
            );
        }

        return <InfoBoxView messages={messages} styles={this.getTypeStyles(this.props.type)} />;
    }
}

const styles = {
    container: {
        borderWidth: 1,
        borderRadius: 4,
        paddingTop: 5,
        paddingBottom: 5,
        paddingLeft: 10,
        marginBottom: 5,
    },
    message: {
        alignSelf: 'stretch',
        fontSize: 14,
        width: '100%',
        marginBottom: 0,
    },
};

const InfoBoxView = (props) => (
    <div style={extend(styles.container, props.styles)}>
        {props.messages.length === 1 && <label style={styles.message}>{props.messages[0]}</label>}

        {props.messages.length > 1 &&
            props.messages.map((message, index) => (
                <label style={styles.message} key={'e' + index}>
                    • {message}
                </label>
            ))}
    </div>
);
